import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const ContractSign = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '合同编号',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumber'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '签署链接',
            dataIndex: 'signUrl',
            key: 'signUrl',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'signUrl'
            },
            filteredValue: filteredInfo.signUrl || [],
        },
        {
            title: '签署标题',
            dataIndex: 'signTitle',
            key: 'signTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.signTitle || [],
        },
        {
            title: '签署人名称',
            dataIndex: 'signName',
            key: 'signName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.signName || [],
        },
        {
            title: '签署人电话',
            dataIndex: 'signPhone',
            key: 'signPhone',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.signPhone || [],
        },
        {
            title: '签署状态',
            dataIndex: 'signStatus',
            key: 'signStatus',
            scopedSlots: {
                filterDropdown: 'filterSignStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'signStatus'
            },
            filteredValue: filteredInfo.signStatus || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    
        {
            title: '销售',
            key: 'salesName',
            scopedSlots: {
                customRender: 'salesName'
            },
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark'
        },
    ]
}
